/*
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 视频列表配置
 */

export const videoListConfig = {
	phrm: {
		title: '平湖一院加速康复指南',
		bottomTip: '平湖一院营养科 0573-85827442',
		list: [
			{
				title: '加速康复外科，舒适化就医体验（上）',
        key:"1",
				src:
					'https://goeasy-im-hlxj.oss-cn-hangzhou.aliyuncs.com/video-2/%E5%8A%A0%E9%80%9F%E5%BA%B7%E5%A4%8D%E5%A4%96%E7%A7%91%EF%BC%8C%E8%88%92%E9%80%82%E5%8C%96%E5%B0%B1%E5%8C%BB%E4%BD%93%E9%AA%8C%EF%BC%88%E4%B8%8A%EF%BC%89-%E9%80%9A%E7%94%A8%E7%89%88.mp4',
				poster:
					'https://goeasy-im-hlxj.oss-accelerate.aliyuncs.com/video/18004379613579919376931718092689_.pic.jpg?Expires=947798092835&OSSAccessKeyId=LTAI5t7QfdzJGq6FobzeHVST&Signature=iTYw20d7uiW02CWV9i5uFWxbg0g%3D'
			},
			{
				title: '加速康复外科，舒适化就医体验（下）',
        key:"2",
				poster:
					'https://goeasy-im-hlxj.oss-accelerate.aliyuncs.com/video/18004377310865080336941718092709_.pic.jpg?Expires=947798092780&OSSAccessKeyId=LTAI5t7QfdzJGq6FobzeHVST&Signature=C0EJzj3pWfx2HZ6tUC55fqO7DCQ%3D',
				src:
					'https://goeasy-im-hlxj.oss-cn-hangzhou.aliyuncs.com/video-2/%E5%8A%A0%E9%80%9F%E5%BA%B7%E5%A4%8D%E5%A4%96%E7%A7%91%EF%BC%8C%E8%88%92%E9%80%82%E5%8C%96%E5%B0%B1%E5%8C%BB%E4%BD%93%E9%AA%8C%EF%BC%88%E4%B8%8B%EF%BC%89-%E9%80%9A%E7%94%A8%E7%89%88.mp4'
			},
			{
				title: '基本膳食',
        key:"3",
				poster:
					'https://goeasy-im-hlxj.oss-accelerate.aliyuncs.com/video/1801119770123116545WX20240613-130858%402x.png?Expires=947798255392&OSSAccessKeyId=LTAI5t7QfdzJGq6FobzeHVST&Signature=BgABXeZ3UOW89Rpaj0ARO%2BTJJXc%3D',
				src: 'https://goeasy-im-hlxj.oss-cn-hangzhou.aliyuncs.com/video-2/%E8%A7%86%E9%A2%913.mp4'
			}
		]
	},
	cxrm: {
		title: '长兴县人民医院骨科加速康复指南',
		list: [
			{
				title: '加速康复外科，舒适化就医体验（上）',
        key:"1",
				src:
					'https://goeasy-im-hlxj.oss-cn-hangzhou.aliyuncs.com/video-2/%E5%8A%A0%E9%80%9F%E5%BA%B7%E5%A4%8D%E5%A4%96%E7%A7%91%EF%BC%8C%E8%88%92%E9%80%82%E5%8C%96%E5%B0%B1%E5%8C%BB%E4%BD%93%E9%AA%8C%EF%BC%88%E4%B8%8A%EF%BC%89-%E9%80%9A%E7%94%A8%E7%89%88.mp4',
				poster:
					'https://goeasy-im-hlxj.oss-accelerate.aliyuncs.com/video/18004379613579919376931718092689_.pic.jpg?Expires=947798092835&OSSAccessKeyId=LTAI5t7QfdzJGq6FobzeHVST&Signature=iTYw20d7uiW02CWV9i5uFWxbg0g%3D'
			},
			{
				title: '加速康复外科，舒适化就医体验（下）',
        key:"2",
				poster:
				"https://pinghu-blood.oss-accelerate.aliyuncs.com/loss_image/182317365390939750637181723513403_.pic.jpg?Expires=947803513446&OSSAccessKeyId=LTAI5t7QfdzJGq6FobzeHVST&Signature=BQvGEWv8F1INmZQKrITTqgBxIUI%3D",
				src:"https://pinghu-blood.oss-accelerate.aliyuncs.com/loss_image/1823172499297198081%E5%8A%A0%E9%80%9F%E5%BA%B7%E5%A4%8D%E5%A4%96%E7%A7%91%EF%BC%8C%E8%88%92%E9%80%82%E5%8C%96%E5%B0%B1%E5%8C%BB%E4%BD%93%E9%AA%8C%EF%BC%88%E4%B8%8B%EF%BC%89%281%29-1.mp4?Expires=947803513216&OSSAccessKeyId=LTAI5t7QfdzJGq6FobzeHVST&Signature=kDOHXxYVso7DZs73gkZxAcSkqVc%3D"
			}
		]
	},
	carm: {
		title: '淳安县人民医院加速康复指南',
		list: [
			{
				title: '加速康复外科，舒适化就医体验（上）',
        key:"1",
				src:
					'https://goeasy-im-hlxj.oss-cn-hangzhou.aliyuncs.com/video-2/%E5%8A%A0%E9%80%9F%E5%BA%B7%E5%A4%8D%E5%A4%96%E7%A7%91%EF%BC%8C%E8%88%92%E9%80%82%E5%8C%96%E5%B0%B1%E5%8C%BB%E4%BD%93%E9%AA%8C%EF%BC%88%E4%B8%8A%EF%BC%89-%E9%80%9A%E7%94%A8%E7%89%88.mp4',
				poster:
					'https://goeasy-im-hlxj.oss-accelerate.aliyuncs.com/video/18004379613579919376931718092689_.pic.jpg?Expires=947798092835&OSSAccessKeyId=LTAI5t7QfdzJGq6FobzeHVST&Signature=iTYw20d7uiW02CWV9i5uFWxbg0g%3D'
			},
			{
				title: '加速康复外科，舒适化就医体验（下）',
        key:"2",
				poster:
					'https://goeasy-im-hlxj.oss-accelerate.aliyuncs.com/video/18004377310865080336941718092709_.pic.jpg?Expires=947798092780&OSSAccessKeyId=LTAI5t7QfdzJGq6FobzeHVST&Signature=C0EJzj3pWfx2HZ6tUC55fqO7DCQ%3D',
				src:
					'https://goeasy-im-hlxj.oss-cn-hangzhou.aliyuncs.com/video-2/%E5%8A%A0%E9%80%9F%E5%BA%B7%E5%A4%8D%E5%A4%96%E7%A7%91%EF%BC%8C%E8%88%92%E9%80%82%E5%8C%96%E5%B0%B1%E5%8C%BB%E4%BD%93%E9%AA%8C%EF%BC%88%E4%B8%8B%EF%BC%89-%E9%80%9A%E7%94%A8%E7%89%88.mp4'
			}
		]
	},jxey: {
		title: '嘉兴二院加速康复指南',
		bottomTip: '嘉兴二院临床营养科',
		list: [
			{
				title: '加速康复外科，舒适化就医体验（上）',
				key:"1",
				src:'https://pinghu-blood.oss-accelerate.aliyuncs.com/video/2013485223461056514',
				poster:
					'https://goeasy-im-hlxj.oss-accelerate.aliyuncs.com/video/18004379613579919376931718092689_.pic.jpg?Expires=947798092835&OSSAccessKeyId=LTAI5t7QfdzJGq6FobzeHVST&Signature=iTYw20d7uiW02CWV9i5uFWxbg0g%3D'
			},
			{
				title: '加速康复外科，舒适化就医体验（下）',
				key:"2",
				poster:
					"https://pinghu-blood.oss-accelerate.aliyuncs.com/loss_image/182317365390939750637181723513403_.pic.jpg?Expires=947803513446&OSSAccessKeyId=LTAI5t7QfdzJGq6FobzeHVST&Signature=BQvGEWv8F1INmZQKrITTqgBxIUI%3D",
				src:"https://pinghu-blood.oss-accelerate.aliyuncs.com/video/2013485882184888322"
			}
		]
	}
};
